import { FC, useState } from 'react'
import { EditorContent, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Placeholder from '@tiptap/extension-placeholder'
import { Bold, CornerDownLeft, CornerDownRight } from 'lucide-react'

interface Props {
  initialHtml: string
  id_suggestion: string
  onSave: (html: string, id_suggestion: string) => Promise<void>
}

const ContractEditor: FC<Props> = ({ initialHtml, onSave, id_suggestion }) => {
  const [saving, setSaving] = useState(false)

  const editor = useEditor({
    extensions: [StarterKit, Placeholder.configure({ placeholder: 'Digite seu contrato aqui…' })],
    content: initialHtml
  })

  if (!editor) return null

  // helper para classes de botão
  const btn = (active: boolean) =>
    `p-2 rounded-md hover:bg-primary-hover transition-colors ${active ? 'bg-primary text-foreground-secondary ' : 'text-primary'}`

  return (
    <div className="border rounded-lg shadow-sm">
      {/* Toolbar */}
      <div className="flex flex-wrap gap-1 bg-white border-b px-2 py-2 sticky top-0 z-10">
        <button
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={btn(editor.isActive('bold'))}
          title="Negrito"
        >
          <Bold size={16} />
        </button>

        <button onClick={() => editor.chain().focus().undo().run()} className={btn(false)} title="Desfazer">
          <CornerDownLeft size={16} />
        </button>

        <button onClick={() => editor.chain().focus().redo().run()} className={btn(false)} title="Refazer">
          <CornerDownRight size={16} />
        </button>
      </div>

      {/* Área de edição */}
      <EditorContent editor={editor} className="prose prose-sm max-w-full min-h-[300px] p-4 outline-none" />

      {/* Botão salvar */}
      <div className="p-4 border-t bg-gray-50 text-right">
        <button
          onClick={async () => {
            setSaving(true)
            const html = editor.getHTML()
            await onSave(html, id_suggestion)
            setSaving(false)
          }}
          disabled={saving}
          className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors disabled:opacity-50"
        >
          {saving ? 'Salvando…' : 'Salvar'}
        </button>
      </div>
    </div>
  )
}

export default ContractEditor
